export default __webpack_public_path__ + "static/media/7.dc6199f7.jpg";